import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import i18n from '../i18n'

Vue.use(Router)

const router = new Router({
  // base: "tools-web-pages", // 根路径，与vue.config.js里的publicPath一致
  mode: 'history', // 路径里就不会有#号
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title)
  }
  next()
})

export default router